var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('h2',[_vm._v(_vm._s(_vm.title))])])])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dashboard-flot-chart",attrs:{"id":_vm.id}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f07bcbb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardChart.vue
// module id = null
// module chunks = 